package co.gul.ui.theme

import org.jetbrains.compose.web.css.StyleScope

fun StyleScope.textAlign(value: String) = property("text-align", value)
fun StyleScope.whiteSpace(value: String) = property("white-space", value)
fun StyleScope.fontStyle(value: String) = property("font-style", value)
fun StyleScope.cursor(value: String) = property("cursor", value)
fun StyleScope.listStyle(value: String) = property("list-style", value)
fun StyleScope.userSelect(value: String) = property("user-select", value)
